<div
  class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col"
>
  <!-- <div class="flex flex-col space-y-1.5 p-6"> -->
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <h3 class="text-2xl font-semibold leading-none tracking-tight">
      Administración de Productos
    </h3>

    <button type="button" class="primary normal" (click)="openModal()">
      + Nuevo Producto
    </button>
  </div>

  <div class="grow h-full p-6 pt-0 min-h-0">
    <app-data-table
      [data]="products"
      [columns]="columns"
      [searchable]="true"
      [selectable]="false"
    >
      <ng-template #cellTemplate let-row="row" let-col="col">
        @if (col.key === "product") {
          <div class="flex items-center space-x-3">
            <div
              class="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center shrink-0"
            >
              <ng-icon
                name="lucidePackage"
                class="w-5 h-5 text-secondary-foreground"
              ></ng-icon>
            </div>
            <div>
              <p class="text-foreground font-medium text-sm">
                {{ row.name }}
              </p>
              <p class="text-muted-foreground text-xs">
                {{ row.description }}
              </p>
            </div>
          </div>
        } @else if (col.key === "categories") {
          <div class="flex flex-row items-center flex-wrap gap-1">
            @for (category of row.product_categories; track category.id) {
              <span
                class="px-2.5 py-0.5 rounded-full text-xs font-medium border text-nowrap text-[0.65rem]"
              >
                {{ category.name }}
              </span>
            }
          </div>
        } @else if (col.key === "actions") {
          <div class="flex items-center justify-center space-x-1">
            <button
              class="ghost sm text-muted-foreground hover:text-foreground"
              type="button"
              (click)="updateProduct(row)"
            >
              <ng-icon
                name="lucidePenLine"
                class="w-5 h-5 text-secondary-foreground"
              ></ng-icon>
            </button>

            <button
              class="ghost sm text-destructive"
              type="button"
              (click)="deleteProduct(row.id)"
            >
              <ng-icon
                name="lucideTrash2"
                class="w-5 h-5 text-secondary-foreground"
              ></ng-icon>
            </button>
          </div>
        }
      </ng-template>
    </app-data-table>
  </div>
</div>

<app-product-form
  [(showModal)]="showModal"
  [existingProduct]="existingProduct"
></app-product-form>
